import Vue from 'vue'
import numeral from 'numeral'
import { priceFormat } from '@/utils/utils'
import { PRODUCT_STATUS } from '@/enums/status.enum'
import dayjs from '@/helpers/dayjs'

Vue.filter('currency', (val) => numeral(val).format('0,0.00'))
Vue.filter('comma', (val) => numeral(val).format('0,0'))

Vue.filter('currencyTh', (val) => priceFormat(val))
Vue.filter('productType', (val) => PRODUCT_STATUS[val])
Vue.filter('dateTh', (val) => dayjs(val).format('DD/MM/YYYY HH:mm'))
// API ส่งเวลา UTC แบบไม่มี offset ต้อง parse เป็น UTC ก่อน
// แล้วตรึงที่ +7 เสมอ ไม่อิง timezone ของเครื่องคนดู
Vue.filter('dateTh7', (val) =>
  dayjs.utc(val).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
)
Vue.filter('dateZoneTh', (val) =>
  dayjs(val).format('YYYY-MM-DD HH:mm:ss'),
)
